<template>
  <a-drawer width="35%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose" destroy-on-close>
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-form-model-item label="类型" prop="type" >
          <a-radio-group disabled v-model="form.type">
            <a-radio :value="1">文章</a-radio>
            <a-radio :value="2">短视频</a-radio>
          </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="标题" prop="title" v-if="form.title">
        <a-input disabled v-model="form.title" placeholder="请输入内容" allow-clear />
      </a-form-model-item>
      <a-form-model-item label="图片" prop="url" v-if="form.url && form.type ==1">
        <img  v-viewer v-for="item in form.url.split(',')"  style="width: 48px;height: 48px;margin-top: 5px;margin-right: 5px;"
             :src="item" preview="头像"/>
      </a-form-model-item>
      <a-form-model-item label="视频" prop="url" v-if="form.url && form.type ==2">
        <video   style="width: 180px;height: 120px"
               class="avatar video-avatar"
               controls="controls"  :src="form.url"/>
      </a-form-model-item>
      <a-form-model-item label="帖子内容" prop="content" v-if="form.content">
        <editor readOnly v-model="form.content" />
      </a-form-model-item>
      <a-form-model-item label="音频" prop="musicUrl" v-if="form.musicUrl">
        <div style="display: flex;flex-direction: row;">
          <audio :src="form.musicUrl" :autoplay="false"
                 controls="controls"/>
          <a style="text-align: center;margin-left: 10px"  @click="removeMusic" v-if="flag == 2">
            <a-icon type="delete" />删除
          </a>
        </div>

      </a-form-model-item>
      <a-form-model-item label="森林" prop="forestName" v-if="form.forestName">
        <a-input disabled v-model="form.forestName" />
      </a-form-model-item>
      <a-form-model-item label="树所在位置" prop="address" v-if="form.city">
        <a-input disabled v-model="form.city" placeholder="请输入树所在位置" />
      </a-form-model-item>
      <a-form-model-item label="是否置顶" prop="isTop" >
        <a-radio-group :disabled="flag !=2 && flag != 3" v-model="form.isTop">
          <a-radio :value="0">否</a-radio>
          <a-radio :value="1">是</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="是否是热门" prop="isHot" >
        <a-radio-group :disabled="flag !=2 && flag != 3"  v-model="form.isHot">
          <a-radio :value="0">否</a-radio>
          <a-radio :value="1">是</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="热门排名" prop="hotRanking" v-if="form.isHot == 1">
       <a-input-number style="width: 300px" :min="0" v-model="form.hotRanking" placeholder="请输入热门排名"/>
      </a-form-model-item>

      <a-form-model-item label="是否推荐" prop="isRecommend" >
        <a-radio-group :disabled="flag !=2 && flag != 3"  v-model="form.isRecommend">
          <a-radio :value="0">否</a-radio>
          <a-radio :value="1">是</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="状态" prop="status" >
        <a-radio-group :disabled="flag != 2" v-model="form.status">
          <a-radio :value="1">待审核</a-radio>
          <a-radio :value="2">审核通过</a-radio>
          <a-radio :value="3">审核驳回</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="驳回原因" prop="rejectReason" v-if="form.status == 3">
        <a-input :disabled="flag != 2" v-model="form.rejectReason" placeholder="请输入驳回原因" />
      </a-form-model-item>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" v-if="flag==2 || flag == 3" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel">
            取消
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getInfo, addInfo, updateInfo } from '@/api/tree/info'
import Editor from '@/components/Editor'

export default {
  name: 'CreateForm',
  props: {
  },
  components: {
    Editor
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      flag:null,
      // 表单参数
      form: {
        id: null,
        nickname: null,
        type: null,
        title: null,
        url: null,
        content: null,
        musicUrl: null,
        forestName: null,
        isTop: null,
        isHot: null,
        hotRanking:null,
        isRecommend: null,
        address: null,
        status: 0,
        rejectReason: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        isPlatform: [
          { required: true, message: '是否平台发布 0-否 1-是不能为空', trigger: 'blur' }
        ],
        userId: [
          { required: true, message: '发布用户 ｛user.id｝不能为空', trigger: 'blur' }
        ],
        title: [
          { required: true, message: '标题不能为空', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      debugger
      if (this.$refs.audioPlayer) {
        this.$refs.audioPlayer.pause(); // 停止音频播放
        this.$refs.audioPlayer = null; // 清除引用
      }
      this.open = false
      this.reset()
    },
    // 表单重置
    reset () {
      this.formType = 1
      this.flag = null
      this.form = {
        id: null,
        nickname: null,
        avatar:null,
        type: null,
        title: null,
        url: null,
        content: null,
        musicUrl: null,
        forestName: null,
        isTop: null,
        isHot: null,
        hotRanking:null,
        isRecommend: null,
        address: null,
        status: 0,
        rejectReason: null,
      }
      this.$nextTick(() => {
        if(this.$refs.form){
          this.$refs.form.resetFields()
        }
      })
    },
    /** 新增按钮操作 */
    handleAdd (row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = '添加'
    },
    removeMusic(){
      this.form.musicUrl =''
    },
    handleInfo(row, flag){
      this.reset()
      this.formType = 2
      this.flag=flag
      const id = row ? row.id : ids
      getInfo({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        this.isInfo = true
        this.formTitle = '详情'
      })
    },
    /** 修改按钮操作 */
    handleUpdate (row, flag) {
      this.reset()
      this.formType = 2
      this.flag = flag
      const id = row ? row.id : ids
      getInfo({"id":id}).then(response => {
        this.form = response.data
        this.open = true
        if(this.flag == 2){
          this.formTitle = '审核'
        }else{
          this.formTitle = '编辑'
        }
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined && this.form.id !== null) {
            updateInfo(this.form).then(response => {
              this.$message.success(
                '修改成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          } else {
            addInfo(this.form).then(response => {
              this.$message.success(
                '新增成功',
                3
              )
              this.open = false
              this.$emit('ok')
            }).finally(() => {
              this.submitLoading = false
            })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>
